import React from 'react'
import PropTypes from 'prop-types'
import scriptjs from 'scriptjs'
import { TextField } from '../..'
import * as translationService from './../../../services/translationService'
import { DropdownMenu } from '../../DropdownMenu'
import { ActionList } from '../../ActionList'

const ADDRESS_MAP = {
  street_number: 'number',
  route: 'street',
  locality: 'city',
  postal_code: 'zip',
  country: 'countryId',
}

const mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API

const PlacesAutocomplete = ({ onSelect }) => {
  const [lookupAddress, setLookupAddress] = React.useState([])
  const [autocompleteService, setAutocompleteService] = React.useState()
  const [placesService, setPredictionsService] = React.useState()
  const [predictions, setPredictions] = React.useState([])
  const [showDropdown, setShowDropdown] = React.useState(false)

  let searchBoxRef = React.createRef()

  React.useEffect(() => {
    const googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${mapsApiKey}&libraries=places`
    scriptjs(googleMapURL, handleMapsLoaded)
  }, [])

  const handleMapsLoaded = () => {
    if (window.google && window.google.maps) {
      setAutocompleteService(new window.google.maps.places.AutocompleteService(searchBoxRef.current))
      setPredictionsService(new window.google.maps.places.PlacesService(searchBoxRef.current))
    }
  }

  React.useEffect(
    () => {
      if (autocompleteService) lookupPlaces(lookupAddress)
    },
    [lookupAddress],
  )

  const handleBlur = () => {
    setTimeout(() => {
      setShowDropdown(false)
    }, 500)
  }

  const handleFocus = () => {
    predictions && predictions.length > 0 && setShowDropdown(true)
  }

  const handleLookupChange = ({ target: { value } }) => {
    setLookupAddress(value)
  }

  const handleKeyDown = event => {
    if (event.keyCode === 13) {
      event.preventDefault()
      handleBlur(event)
    }
  }

  const lookupPlaces = address => {
    if (!address || address === '') return
    autocompleteService.getQueryPredictions({ input: address }, (result, status) => {
      if (status != window.google.maps.places.PlacesServiceStatus.OK) {
        console.warn(status)
        return
      }
      if (result && result.length > 0) {
        setPredictions(result)
        setShowDropdown(true)
      } else {
        setPredictions([])
        setShowDropdown(false)
      }
    })
  }

  const optionRender = option => {
    return <div>{option.data.description}</div>
  }

  const onPlaceSelect = async place => {
    const componentForm = {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      country: 'long_name',
      postal_code: 'short_name',
    }
    let address = {
      number: '',
      street: '',
      city: '',
      zip: '',
      countryId: 'BE',
    }
    setLookupAddress(place.description)
    placesService.getDetails(
      { placeId: place.place_id, fields: ['address_component', 'opening_hours', 'geometry'] },
      (placeDetails, status) => {
        if (status != window.google.maps.places.PlacesServiceStatus.OK) {
          console.warn(status)
          return
        }

        if (placeDetails.address_components === undefined) return

        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        for (var i = 0; i < placeDetails.address_components.length; i++) {
          var addressType = placeDetails.address_components[i].types[0]
          if (componentForm[addressType]) {
            var val = placeDetails.address_components[i][componentForm[addressType]]
            address[ADDRESS_MAP[addressType]] = val
          }
          if (addressType === 'country') {
            address.countryCode = placeDetails.address_components[i].short_name
          }
        }

        address.googlePlaceId = placeDetails.place_id

        onSelect(address)
        setShowDropdown(false)
      },
    )
  }

  return (
    <DropdownMenu
      content={
        <ActionList
          items={predictions.map(option => {
            return optionRender
              ? {
                  content: optionRender({ data: option }),
                  data: option,
                  onClick: () => onPlaceSelect(option),
                }
              : { content: option.value || '' }
          })}
        />
      }
      tooltipShown={showDropdown}
      trigger="none"
      placement="bottom-start"
      modifiers={{
        setWidth: {
          enabled: true,
          order: 840,
          fn(data) {
            if (data.offsets.reference.height >= 84 && data.offsets.popper.top > data.offsets.reference.top) {
              data.offsets.popper.top = data.offsets.popper.top - 24
            }
            if (data.offsets.popper.top < data.offsets.reference.top) {
              data.offsets.popper.top = data.offsets.popper.top + 24
            }
            data.offsets.popper.left = data.offsets.reference.left
            data.offsets.popper.right = data.offsets.reference.right
            data.offsets.popper.width = data.styles.width = Math.round(data.offsets.reference.width)
            return data
          },
        },
      }}>
      <div>
        <TextField
          label={translationService.fullAddress()}
          helpText={translationService.fullAddressHelptext()}
          type="text"
          name="googlePlaces"
          innerRef={searchBoxRef}
          id="googlePlaces"
          value={lookupAddress}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onKeyDown={handleKeyDown}
          onChange={handleLookupChange}
          className="form-control"
          autoComplete="off"
        />
      </div>
    </DropdownMenu>
  )
}
PlacesAutocomplete.propTypes = {
  onSelect: PropTypes.func,
}

export default PlacesAutocomplete



// WEBPACK FOOTER //
// ./src/components/Form/PlaceAutocomplete/PlaceAutocomplete.js